import { IParams } from './IParams';

export function toSearch(params: IParams): string {
  if (!params)
    return null;

  return Object.keys(params).reduce(
    (search, key, i) => {
      const param = params[key];
      if (param == null) return search

      const values = Array.isArray(param)
        ? param
        : [param];

      values.forEach(value => {
        if (i) search += '&';
        search += `${key}=${value}`;
      })

      return search;
    },
    '?'
  );
}
